import React from "react";
import Header from "./Components/header/Header";
import "./App.css";
import Home from "./Components/Home/Home";
import About from "./Components/about/AboutMe";
import Skills from "./Components/Skills/Skills";
import Services from "./Components/Services/Services";
import Qualification from "./Components/qualification/qualification";
import TestiMonials from "./Components/Testimonials/Testimonials";
import Contact from "./Components/Contact/Contact";
import Footer from "./Components/Footer/Footer";
import ScrollUp from "./Components/ScrollUp/Scrollup";

function App() {
  return (
    <>
      <Header />

      <main className="main">
        <Home />
        <About />
        <Skills />
        <Services />
        <Qualification />
        <TestiMonials />
        <Contact/>
        
      </main>
      <Footer/>
      <ScrollUp/>
    </>
  );
}

export default App;
